<template>
    <div class="main-layout">
        <headerMain layout="main" />
        <main class="main">
            <div class="main-wrapp">
                <navbar/>
                <div class="right-section">
                    <router-view />
                </div>
            </div>
        </main>
        <modalSearch/>
        <footerMain/>
    </div>
</template>

<script>
import footerMain from '@/components/app/footerMain';
import headerMain from '@/components/app/headerMain';
import modalSearch from '@/components/app/modals/modal-search';
import navbar from '@/components/app/profile/navbar';

export default {
  name: 'main-layout',
  components:{
    navbar,headerMain, footerMain, modalSearch
  }
};
</script>

<style lang="scss">
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '../assets/sass/app/app.scss';
</style>
